export const DASHBOARD_COLORS = {
  primary: '#00758d', // Turquoise SING
  secondary: '#00303c', // Dark blue
  accent: '#8E0B56', // Magenta
  success: '#059669', // Emerald 600
  warning: '#d97706', // Amber 600
  error: '#e11d48', // Rose 600
};
